import { PlanoDialog } from './plano.dialog';

export class PlanoDialogViewModel {

    constructor() {}

    context: PlanoDialog

    setContext(context: PlanoDialog) {
        this.context = context
    }

    getContext(): PlanoDialog {
        return this.context
    }
}